import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageManagementRoutingModule } from './image-management-routing.module';
import { UbsViewContainersModule } from '@urbannex/view-containers';
import { ImageManagementComponent } from './image-management.component';
import { ProductImagesComponent } from './product-images/product-images.component';
import { UploadAdditionalImagesComponent } from './product-images/upload-additional-images/upload-additional-images.component';
import { ManageImagesComponent } from './product-images/manage-images/manage-images.component';
import { ApproveImagesComponent } from './product-images/approve-images/approve-images.component';
import { ReplaceImagesComponent } from './product-images/replace-images/replace-images.component';
import { ResizeImagesComponent } from './product-images/resize-images/resize-images.component';



@NgModule({
  declarations: [ImageManagementComponent, ProductImagesComponent, UploadAdditionalImagesComponent, ManageImagesComponent, ApproveImagesComponent, ReplaceImagesComponent, ResizeImagesComponent],
  imports: [
    CommonModule,
    ImageManagementRoutingModule,
    UbsViewContainersModule
  ],
  exports:[]
})
export class ImageManagementModule { }
